export default "__VITE_ASSET__DryokBgT__"